// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const audino_mega: PokeData = {
  "id": 10069,
  "name": "audino-mega",
  "height": 15,
  "weight": 320,
  "base_experience": 425,
  "types": [
    PokeType.NORMAL,
    PokeType.FAIRY
  ],
  "api_moves": [
    "pound",
    "double-slap",
    "take-down",
    "double-edge",
    "growl",
    "attract",
    "helping-hand",
    "refresh",
    "secret-power",
    "hyper-voice",
    "last-resort",
    "simple-beam",
    "entrainment",
    "after-you",
    "heal-pulse",
    "disarming-voice",
    "misty-terrain",
    "play-nice",
    "baby-doll-eyes"
  ],
  "moves": [
    "growl",
    "refresh",
    "hyper-voice",
    "misty-terrain",
    "spirit-break",
    "tackle",
    "scary-face",
    "tri-attack",
    "supersonic",
    "sweet-kiss",
    "leer",
    "moonblast",
    "dazzling-gleam"
  ],
  "evolution_chain": {
    "id": 271,
    "item": null,
    "species": [
      {
        "name": "audino",
        "order": 532,
        "types": [
          PokeType.NORMAL
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 187,
    "speed": 82,
    "ability_power": 131
  },
  "stat_changes": [],
  "catch_rate": 255,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": true,
  "is_gmax": false,
  "regional_variant": null
} as const;
